import useScreenSize from "./useScreenSize";

/**
 * Alias für useScreenSize mit XL-Breakpoint (1280px).
 * Wird in Gutachten-Komponenten verwendet, die mehr horizontalen Platz benötigen.
 */
const useScreenSize1 = () => useScreenSize(1280);

export default useScreenSize1;